/*
 * Green Passion pre-order cart notice (see snippets/gp-preorder.liquid).
 * Reads /cart.js and shows a notice when the cart holds a line with the
 * `_preorder` property: in the Kaching Cart drawer and on the /cart page.
 */
(function () {
  var cfg = window.GP_PREORDER;
  if (!cfg) return;

  // Translation strings arrive HTML-escaped (e.g. &#39;); notices are set as text
  function decode(html) {
    var t = document.createElement('textarea');
    t.innerHTML = html;
    return t.value;
  }
  Object.keys(cfg.notices).forEach(function (k) { cfg.notices[k] = decode(cfg.notices[k]); });
  cfg.soon = decode(cfg.soon || '');

  var NOTICE_CLASS = 'gp-preorder-notice';
  var message = '';
  var fetching = null;

  function buildMessage(cart) {
    var latest = null;
    var others = 0;
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (!props._preorder) { others++; return; }
      // Keep the pre-order line with the latest ship date; its _preorder_when is already localised
      if (!latest || String(props._preorder) > String(latest._preorder)) latest = props;
    });
    if (!latest) return '';
    var text = others ? cfg.notices[cfg.mode === 'together' ? 'together' : 'split'] : cfg.notices.only;
    return text.replace('[date]', latest._preorder_when || cfg.soon);
  }

  function render() {
    // Cart page placeholder
    document.querySelectorAll('[data-gp-preorder-notice]').forEach(function (el) {
      el.textContent = message;
      el.hidden = !message;
    });

    // Kaching Cart drawer: re-inserted whenever Kaching re-renders its items
    var items = document.querySelector('#kaching-cart .kaching-cart-item-container');
    var existing = document.querySelector('#kaching-cart .' + NOTICE_CLASS);
    if (!message || !items) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement('div');
      existing.className = NOTICE_CLASS + ' ' + NOTICE_CLASS + '--drawer';
      existing.setAttribute('role', 'status');
    }
    if (existing.textContent !== message) existing.textContent = message;
    if (existing.nextElementSibling !== items) items.parentNode.insertBefore(existing, items);
  }

  function refresh() {
    if (fetching) return fetching;
    fetching = fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { message = buildMessage(cart); render(); })
      .catch(function () {})
      .finally(function () { fetching = null; });
    return fetching;
  }

  // Refresh after any cart change made through fetch (theme forms, Kaching, bundle builder)
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
    }
    return p;
  };

  // Kaching calls the cart API from its own iframe, so also watch its line items
  function drawerSignature() {
    return Array.prototype.map.call(
      document.querySelectorAll('#kaching-cart .kaching-cart-item'),
      function (el) { return el.getAttribute('data-line-key'); }
    ).join('|');
  }
  var lastSignature = null;
  var renderQueued = false;
  new MutationObserver(function () {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(function () {
      renderQueued = false;
      var sig = drawerSignature();
      if (lastSignature !== null && sig !== lastSignature) refresh();
      lastSignature = sig;
      render();
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();
})();
